import { MenuItem } from 'prosemirror-menu';
import { toggleMark, setBlockType } from 'prosemirror-commands';
import { markActive } from '../utils';
import icons from '../icons';

export function applyMark(markType, key, value) {
  return function (state, dispatch, view) {
    const { tr, selection } = state;

    const { empty, from, to } = selection;

    if (empty) {
      if (value === null) {
        tr.removeStoredMark(markType);
      } else {
        tr.addStoredMark(markType.create({ [key]: value }));
      }
    } else {
      tr.removeMark(from, to, markType);

      if (value !== null) {
        tr.addMark(from, to, markType.create({ [key]: value }));
      }
    }

    if (tr.docChanged || tr.storedMarksSet) {
      if (dispatch) {
        dispatch(tr);
      }
      view.focus();
      return true;
    }

    return false;
  };
}

export const cmdItem = (cmd, options) => {
  const passedOptions = {
    label: options.title,
    run: cmd,
  };
  Object.keys(options).reduce((acc, optionKey) => {
    acc[optionKey] = options[optionKey];
    return acc;
  }, passedOptions);
  if ((!options.enable || options.enable === true) && !options.select) {
    passedOptions[options.enable ? 'enable' : 'select'] = (state) => cmd(state);
  }

  return new MenuItem(passedOptions);
};

export const alignmentItem = (nodeType, alignment) => {
  return new MenuItem({
    title: `Align ${alignment}`,
    icon: icons[alignment],
    active(state) {
      const { $from, to } = state.selection;
      const node = state.doc.nodeAt($from.pos);
      return node && node.attrs && node.attrs.align === alignment;
    },
    enable(state) {
      return setBlockType(nodeType, { align: alignment, autoDetected: false })(state);
    },
    run(state, dispatch, view) {
      setBlockType(nodeType, { align: alignment, autoDetected: false })(state, dispatch);
      view.focus();
    },
  });
}

export const markItem = (markType, options) => {
  const passedOptions = {
    active(state) {
      return markActive(state, markType);
    },
    enable: true,
  };
  Object.keys(options).reduce((acc, optionKey) => {
    acc[optionKey] = options[optionKey];
    return acc;
  }, passedOptions);
  return cmdItem(toggleMark(markType), passedOptions);
};

export const blockTypeIsActive = (state, type, attrs) => {
  const { $from } = state.selection;

  let wrapperDepth;
  let currentDepth = $from.depth;
  while (currentDepth > 0) {
    const currentNodeAtDepth = $from.node(currentDepth);

    const comparisonAttrs = {
      ...attrs,
    };
    if (currentNodeAtDepth.attrs.level) {
      comparisonAttrs.level = currentNodeAtDepth.attrs.level;
    }
    const isType = type.name === currentNodeAtDepth.type.name;
    const hasAttrs = Object.keys(attrs).reduce((prev, curr) => {
      if (attrs[curr] !== currentNodeAtDepth.attrs[curr]) {
        return false;
      }
      return prev;
    }, true);

    if (isType && hasAttrs) {
      wrapperDepth = currentDepth;
    }
    currentDepth -= 1;
  }

  return wrapperDepth;
};

export const toggleBlockType = (type, attrs) => (state, dispatch) => {
  const isActive = blockTypeIsActive(state, type, attrs);
  const newNodeType = isActive ? state.schema.nodes.paragraph : type;
  const setBlockFunction = setBlockType(newNodeType, attrs);
  return setBlockFunction(state, dispatch);
};
